export default "__VITE_ASSET__ClRTyfiw__"